import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon, UsersIcon, GraduationCapIcon, HeartIcon, MapPinIcon } from 'lucide-react';
const trustItems = [{
  icon: ShieldCheckIcon,
  text: 'Serving Hurst Since 2008'
}, {
  icon: UsersIcon,
  text: 'Family-Friendly Academy'
}, {
  icon: GraduationCapIcon,
  text: 'Ages 3 Through Adult'
}, {
  icon: HeartIcon,
  text: 'Specialized Spectrum Program'
}, {
  icon: MapPinIcon,
  text: 'Convenient to Colleyville Families'
}];
export function TrustStrip() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  return <section className="bg-warm-100 py-6 md:py-8 border-b border-warm-200" ref={ref} data-id="element-425">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-426">
        <motion.div className="flex flex-wrap justify-center md:grid md:grid-cols-5 gap-4 md:gap-0" initial={{
        opacity: 0,
        y: 10
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} data-id="element-427">
          {trustItems.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className={`flex items-center gap-3 px-4 py-2 w-full sm:w-auto md:w-full md:justify-center ${index !== trustItems.length - 1 ? 'md:border-r md:border-warm-300' : ''}`} data-id="element-428">
                <Icon className="w-5 h-5 text-amber-dark shrink-0" data-id="element-429" />
                <span className="text-sm font-medium text-navy-950 leading-tight" data-id="element-430">
                  {item.text}
                </span>
              </div>;
        })}
        </motion.div>
      </div>
    </section>;
}